module.exports = {
	forceScope: 'newsletter', // TODO: forceScope necessary since scope rework?

	model: {
		additionalDataFieldsByMailingListID: {},
		limitSubscribersToMailingID: 0,
		entityTable: false
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				if($target.length > 0){
					var fieldType = $target.data('fieldType');
					if(self.model.entityTable){
						if(self.model.limitSubscribersToMailingID <= 0 && fieldType === 'export'){
							self.model.entityTable.export()
						} else if(self.model.limitSubscribersToMailingID <= 0 && fieldType === 'showInsert'){
							self.model.entityTable.showInsert()
						} else if(self.model.limitSubscribersToMailingID <= 0 && fieldType === 'showImport'){
							self.model.entityTable.showImport()
						} else if(fieldType === 'refresh'){
							self.model.entityTable.refreshData()
						}
					}
				}
			}
		}
	},

	methods: {
		dataDealer: function(){
			this.model.limitSubscribersToMailingID = (this.getResourceRegisterContent('subscriberSpecifics') || {}).mailingID || 0;
		},

		sanitizeResources: function(storage){
			const langCode = storage.langCode || appConfig.language.default || 'de-at'

			this.model.additionalDataFieldsByMailingListID = {};
			var mailingListID, fieldIndex, field, options;
			for(mailingListID in this.resourceData.data || {}){
				this.model.additionalDataFieldsByMailingListID[mailingListID] = {};

				for(fieldIndex in this.resourceData.data[mailingListID] || []){
					field = this.resourceData.data[mailingListID][fieldIndex] || {};

					if(field.fieldCode && field.atom){

						// TODO: other pickers needed?
						if(field.atom.dataType === 'tag-picker'){
							this.model.additionalDataFieldsByMailingListID[mailingListID]['a_' + field.fieldCode] = this.prepareTagPickerOptions((field['tag-picker-data'] || {}).options || {});
						} else if(field.atom.dataType === 'category-picker'){
							this.model.additionalDataFieldsByMailingListID[mailingListID]['a_' + field.fieldCode] = this.prepareCategoryPickerOptions((field['category-picker-data'] || {}).options || {}, langCode);
						}
					}
				}
			}
		},

		prepareCategoryPickerOptions: function(options, langCode, list){
			if(!list) list = {};
			if(!list.byKeys) 	list.byKeys = {};
			if(!list.byValues) 	list.byValues = {};

			var o, option, name;
			for(o in options) {
				option = options[o];

				if(((option.lang || {})[langCode] || {}).name){
					name = option.lang[langCode].name;
				} else if(option.value) {
					name = option.value;
				} else {
					name = '';
				}

				if(option.categoryDataID){
					list.byKeys[option.categoryDataID] = name;
				}
				if(option.value){
					list.byValues[option.value] = name;
				}
			}

			return list;
		},

		prepareTagPickerOptions: function(options, list){
			if(!list) list = {};
			if(!list.byKeys) 	list.byKeys = {};
			if(!list.byValues) 	list.byValues = {};

			var tagIndex, tagID, option;
			for(tagIndex in options){
				option = options[tagIndex] || {};

				if((option.resources || {}).categoryID){
					// categoryData
					if(option.resources.categoryDataID){
						tagID = String(option.resources.categoryID) + '_' + String(option.resources.categoryDataID)
					}
					// categories
					else {
						tagID = String(option.resources.categoryID);
					}

					if(option.name){
						list.byKeys[tagID] = option.name;
					} else {
						list.byKeys[tagID] = tagID;
					}
				}

				if(option.children){
					this.prepareTagPickerOptions(option.children, list);
				}
			}

			return list;
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.entityTable){
				self.find('base_tableSimple_table', function(entityTable){
					self.model.entityTable = entityTable;
				});
			}

			if(this.model.limitSubscribersToMailingID > 0){
				this.triggerFind('changeView', { mode: 'mailingSpecific' });
			}
		},

		filtersChanged: function ($element, options) {
			this.triggerFind('filtersChanged', options);
		},

		filterColumnsChanged: function ($element, options) {
			this.triggerFind('filterColumnsChanged', options);
		},

		showColumnDescription: function ($element, options) {
			this.triggerFind('showColumnDescription', options);
		},

		hideColumnDescription: function ($element, options) {
			this.triggerFind('hideColumnDescription', options);
		}
	}
};
